"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV2EmbeddedIsMachineEligible = void 0;
exports.v2EmbeddedIsMachineEligibleSetMock = v2EmbeddedIsMachineEligibleSetMock;
exports.v2EmbeddedIsMachineEligible = v2EmbeddedIsMachineEligible;
exports.useQueryV2EmbeddedIsMachineEligible = useQueryV2EmbeddedIsMachineEligible;
exports.useInfiniteQueryV2EmbeddedIsMachineEligible = useInfiniteQueryV2EmbeddedIsMachineEligible;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v2EmbeddedIsMachineEligibleSetMock(mock) {
    setMock = mock;
}
async function v2EmbeddedIsMachineEligible(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v2/embedded/is-machine-eligible`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV2EmbeddedIsMachineEligible = 'cockatoo:v2EmbeddedIsMachineEligible:get';
function useQueryV2EmbeddedIsMachineEligible(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2EmbeddedIsMachineEligible, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV2EmbeddedIsMachineEligible(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV2EmbeddedIsMachineEligible, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v2EmbeddedIsMachineEligible(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v2-embedded-is-machine-eligible.js.map